<template>
  <el-card>
    <div>
      <el-row>
        <el-date-picker
          v-model="da1"
          value-format="yyyy-MM-dd HH:mm:ss"
          type="datetimerange"
          range-separator="至"
          :unlink-panels="true"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        ></el-date-picker>
        <el-select placeholder="请选择操作类型" v-model="describe">
          <el-option value=0 label="操作">操作</el-option>
          <el-option value=1 label="登录">登录</el-option>
        </el-select>
        <el-button @click="searchthis()">搜索</el-button>
      </el-row>
      <el-table border :data="tableDate" style="width: 100%;margin-top:20px;">
        <el-table-column prop="createTime" label="时间"></el-table-column>
        <el-table-column label="记录" >
          <template slot-scope="scope">
            <span>{{scope.row.loginDescribe}}/</span>
            <span>{{scope.row.name}}/</span>
            <span v-if="scope.row.logType == 1">{{scope.row.email}}/</span>
            <span v-else-if="scope.row.logType == 0">{{scope.row.mobile}}/</span>
            <span v-else-if="scope.row.logType == 2">{{scope.row.username}}/</span>
            <span>{{scope.row.ip}}</span>
          </template>
        </el-table-column>
        <el-table-column label="记录类型">
          <template slot-scope="scope">
          <span v-if="scope.row.isLogin==1">登录</span>
          <span v-else>操作</span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
      style="margin-top:20px;"
        @current-change="handleCurrentChange"
        :page-size="limit"
        :current-page="page"
        background
        layout="prev, pager, next"
        :total="total"
      ></el-pagination>
    </div>
    <div style="height: 50px"></div>
  </el-card>
</template>

<script>
    export default {
    data(){
      return{
        da1:[],
        describe:'',
        total: 0,
        page: 1,
        limit: 20,
        tableDate:[]
      }
    },
      methods:{
      getTableDate:async function () {
        var startDate="";
        var endDate="";
        if(this.da1!=undefined&&this.da1!=null&&this.da1!=""){
          startDate=this.da1[0];
          endDate=this.da1[1];
      }

        var res = await this.$http.get(
          `/v1/log/list?page=${this.page}&startDate=${startDate}&endDate=${endDate}&describe=${this.describe}`
        )
        var {data,message,code,total}=res.data;
        if(code==0){
          this.tableDate=data;
          this.total=total;
        }else {
         this.$message.error(message);
        }
      }
        ,
        handleCurrentChange: function(val) {
          this.page = val;
          this.getTableDate();
        },
        searchthis:function(){
          this.page=1;
          this.getTableDate();
        }
      },
      mounted(){
      this.getTableDate();
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/backgroundMg/log-mg/buslog.vue